import { Component, OnInit, OnDestroy } from "@angular/core";
import { UserModel, UserService} from "@bt/core";
import { map } from 'rxjs/operators';
import { BaseComponent } from "@bt/core/base";
import { NotifierService } from "angular-notifier";
import { ActivatedRoute, Router } from "@angular/router";
import { ChangePasswordByAdmin } from "@bt/core/models/changePasswordByAdmin.model";
import { faEdit,faArrowLeft,faSave } from '@fortawesome/free-solid-svg-icons';



@Component({
  selector: "app-users-profile",
  templateUrl: "./users-profile.component.html",
  styleUrls: ["./users-profile.component.scss"]
})
export class UsersProfileComponent extends BaseComponent implements OnInit, OnDestroy {

  faEdit=faEdit;
  faArrowLeft=faArrowLeft;
  faSave=faSave;

  public userFullName;
  public user: any;
  public currentModel: UserModel;
  public editModel: UserModel;
  public isEditEnable: boolean;
  private readonly notifier: NotifierService;
  private userRole: number;
  private pointsStr: string;
  private id: string;
  public newPassword:string;
  public newPasswordConf:string;
  
  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    notifierService: NotifierService,
    private router: Router
  ) {
    super();
    this.currentModel = new UserModel();
    this.editModel = new UserModel();
    this.isEditEnable = false;
    this.notifier = notifierService;
    this.userRole = userService.getRole();
    this.pointsStr = "0";
  }

  public ngOnInit() {

    this.id = this.route.snapshot.paramMap.get('id');
  }


  public ngOnDestroy() {
    this.userService.reset();
  }

  public getRole() {
    return this.userService.getRole();
  }

  public currentUser() {
    return this.userService.currentUser;
  }

  public enableEdition() {
    this.isEditEnable = true;
  }

  public isPasswordValid() : boolean {
    if(this.newPassword.length <= 5 && this.newPassword.length != 0) {
      this.notifier.notify('error', "Длина пароля должна превышать 5 символов");
      return false; 
    }
    if(this.newPassword!=this.newPasswordConf) {
      this.notifier.notify('error', "Подтвержденный пароль должен совпадать с новым паролем");
      return false; 
    }
    return true; 
  }

  public editPassword() {
    var t = this;
    var model: ChangePasswordByAdmin = {
      userId: t.editModel.id,
      newPassword: t.newPassword,
      newPasswordConf: t.newPasswordConf,
      needSendToEmail: true
    }
    t.userService.changePasswordByAdmin(model)
      .then((resp) => {
        this.notifier.notify('success', "Пароль успешно изменен");
        t.newPassword = null;
        this.setLoading(false);
      })
      .catch((error) => {
        console.error(error.error);
        t.setLoading(false);
      });
  }

  
  public saveChanges() {
    this.setLoading(true);

    if(this.newPassword != null) {
      if(this.isPasswordValid()) {
        this.editPassword();
      }
      else {
        this.setLoading(false);
        return;
      }
    }

    this.userService.editUserInfoByAdmin(this.editModel)
      .then((resp) => {
        // this.currentModel = Object.assign({}, resp.data);
        // this.userService.currentUser = Object.assign({}, resp.data);
        this.isEditEnable = false;
        this.notifier.notify('success', "Данные сохранены");
        this.setLoading(false);
      })
      .catch((error) => {
        console.error(error.error);
      });
  }

}


// WEBPACK FOOTER //
// ./src/app/users-profile/users-profile.component.ts